import React, { useEffect, useRef, useState } from "react";
import "../styles/HomePageStyles/location.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Card } from "react-bootstrap";
import Aos from "aos";
import "aos/dist/aos.css";
// Locations Images
import Ajax from "../assets/Locations/Ajax.jpg";
import Brampton from "../assets/Locations/Brampton.jpg";
import Collingwood from "../assets/Locations/Collingwood.jpg";
import Edmonton from "../assets/Locations/Edmonton.jpg";
import Guelph from "../assets/Locations/Guelph.jpg";
import Kitchener from "../assets/Locations/Kitchener.jpg";
import Lebovic from "../assets/Locations/Lebovic.jpg";
import Meadows from "../assets/Locations/Meadows.jpg";
import Peterborough from "../assets/Locations/Peterborough.jpg";
import Scarborough from "../assets/Locations/Scarborough.jpg";
import Vaughan from "../assets/Locations/Vaughan.jpg";
import Windsor from "../assets/Locations/Windsor.jpg";
import config from "../config";
import { Link } from "react-router";
import doorImg from "../assets/LocationPage/doordash2.png";
import skipImg from "../assets/LocationPage/Skip_2024.webp";
import uberImg from "../assets/LocationPage/ubereats.png";
import axios from "axios";

const TestimonialsLocations = () => {
  Aos.init({
    offset: 0,
    duration: 1000,
    once: true,
    easing: "ease-out-cubic",
    disable: "phone",
  });

  useEffect(() => {
    getAllLocations();
  }, []);

  const [isLoading, setIsLoading] = useState(false);

  const [data, setData] = useState([]);
  const [loc_name, setLocationName] = useState([]);
  const [loc_address, setLocationAdd] = useState("");
  const [loc_image, setLocationImage] = useState("");
  const [loc_phone, setLocationPhone] = useState("");
  const [loc_email, setLocationEmail] = useState("");
  const [loc_map_link, setLocationMapLink] = useState("");
  const [loc_review_link, setLocationReviewLink] = useState("");
  const [loc_order_link1, setOrderLink1] = useState("");
  const [loc_order_link2, setOrderLink2] = useState("");
  const [loc_order_link3, setOrderLink3] = useState("");
  const [loc_order_Img1, setOrderImg1] = useState("");
  const [loc_order_Img2, setOrderImg2] = useState("");
  const [loc_order_Img3, setOrderImg3] = useState("");
  const [loc_ins_link, setLocInsLink] = useState("");
  const [loc_fb_link, setLocFbLink] = useState("");
  const [loc_tiktok_link, setLocTikTokLink] = useState("");
  const [loc_yt_link, setLocYtLink] = useState("");

  const getAllLocations = async () => {
    setIsLoading(true);
    try {
      const response = await axios({
        method: "get",
        url: `${config.apiUrl}/locations`,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        }, 
      }).then((res) => {
        setIsLoading(false);
        setData(res.data.data.filter((loc) => loc.status === 1));
        setLocationName(res.data.data?.location_name);
        setLocationAdd(res.data.data?.location_address);
        setLocationImage(res.data.data?.image);
        setLocationPhone(res.data.data?.phone);
        setLocationEmail(res.data.data?.email);
        setLocationMapLink(res.data.data?.map_link);
        setLocationReviewLink(res.data.data?.review_link);
        setOrderLink1(res.data.data?.order_link1);
        setOrderLink2(res.data.data?.order_link2);
        setOrderLink3(res.data.data?.order_link3);
        setOrderImg1(res.data.data?.order_image1);
        setOrderImg2(res.data.data?.order_image2);
        setOrderImg3(res.data.data?.order_image3);
        setLocInsLink(res.data.data?.instagram_link);
        setLocFbLink(res.data.data?.facebook_link);
        setLocTikTokLink(res.data?.data.tiktok_link);
        setLocYtLink(res.data.data?.youtube_link);
        // console.log("emial", res.data.data?.email);
        // console.log("location name in ",res.data.data?.location_name);

      });
    } catch (error) {
      setIsLoading(false);
      console.log("locations", error);
    }
  };

  const [slidIndex, setSlidIndex] = useState(0);

  const sliderRef = useRef();

  const settings = {
    dots: false,
    fade: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    autoplaySpeed: 2000,
    beforeChange: (current, next) => setSlidIndex(next),
    prevArrow: (
      <button className="custom-arrow slick-prev">
        <i className="bi bi-caret-left-fill"></i>{" "}
      </button>
    ), // Custom Previous Arrow
    nextArrow: (
      <button className="custom-arrow slick-next">
        <i className="bi bi-caret-right-fill"></i>{" "}
      </button>
    ), // Custom Next Arrow
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

 
  return (
    <>
      <div className="location_wrapper contianer_wrapper">
        <div className="container">
          <h2 className="text-center mb-md-4" data-aos="zoom-out">
            Our Locations
          </h2>
          <Slider ref={sliderRef} {...settings}>
            {data.map((card, index) => 
            (
              <div key={index} className="card-slide1">
                <Card
                  className={`location_card p-3 card-color-${(index % 3) + 1}`}
                  key={card.id}
                >
                  <Card.Body className="locationdetails_box_body p-0">
                    <div className="location_img">
                      <Link 
                      to={`${config.appUrl}/${card?.location_name.toLowerCase().replaceAll(",","").replaceAll(" ","-")}`}
                      onClick={() => {

                        localStorage.setItem("location", card.id);
                        localStorage.setItem(
                          "location_name",
                          card?.location_name
                        );
                       
                      }}
                      >
                        <img src={card.image} alt="" className="img-fluid" />
                      </Link>
                    </div>
                    <div className="locationdetails_box">
                      <h4 className="my-3 text-center location_name px-3">
                        {card.location_name}
                      </h4>
                      <p className="text-center location_address px-3">
                        {card.location_address}
                      </p>

                      <div className="locations_details_wrapper">
                        <h4 className="border-bottom py-3 location_direction">
                          <Link
                            // to="https://www.google.com/maps/place/Rollz+Ice+Cream+%26+Desserts/@43.4784711,-80.5257085,18z/data=!4m8!3m7!1s0x882bf3cf766e1161:0x6e8047d9f19537ac!8m2!3d43.4782899!4d-80.5248291!9m1!1b1!16s%2Fg%2F11vptgg7j6?hl=en&entry=ttu&g_ep=EgoyMDI1MDEwMS4wIKXMDSoASAFQAw%3D%3D"
                            to={card.map_link}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Get Direction{" "}
                            <i className="bi bi-arrow-right-short"></i>
                          </Link>
                        </h4>
                        <div className="border-bottom cursor-pointer py-3 d-flex justify-content-center">
                          <a
                            href={`tel:${card.phone}`}
                            className="d-flex align-items-center location_contact"
                          >
                            <h5 className="fw-bold">{card.phone}</h5>
                          </a>
                        </div>
                        <div className="border-bottom py-3 ">
                          <a href={`mailto: ${card.email}`}>
                            <h5 className="fw-bold">{card.email}</h5>
                          </a>
                        </div>

                        {/* <div className="border-bottom py-3 d-flex flex-column">
                          <h5 className="fw-bold mb-3">Order Online</h5>
                          <div className="d-flex justify-content-center align-items-center gap-2">
                            <Link to={card.order_link1} target="_blank">
                              <img
                                src={card.order_image1}
                                className="img-fluid d-flex justify-content-center align-items-center"
                                alt=""
                                style={{
                                  width: "80px",
                                  height: "30px",
                                  backgroundColor: "white",
                                  padding: "2px 10px",
                                  borderRadius: "25px",
                                }}
                              ></img>
                            </Link>
                            <Link to={card.order_link2} target="_blank">
                              <img
                                src={card.order_image2}
                                className="img-fluid d-flex justify-content-center align-items-center"
                                alt="Skip Image"
                                style={{
                                  width: "80px",
                                  height: "30px",
                                  backgroundColor: "white",
                                  padding: "2px 10px",
                                  borderRadius: "25px",
                                }}
                              ></img>
                            </Link>
                            <Link to={card.order_link2} target="_blank">
                              <img
                                src={card.order_image3}
                                className="img-fluid d-flex justify-content-center align-items-center"
                                alt="Uber Image"
                                style={{
                                  width: "80px",
                                  height: "30px",
                                  backgroundColor: "white",
                                  padding: "2px 10px",
                                  borderRadius: "25px",
                                }}
                              ></img>
                            </Link>
                          </div>
                        </div> */}

                        <div className="border-bottom py-3 d-flex flex-column">
                          {/* Check if any of the order-related fields are available */}
                          {card.order_link1 ||
                          card.order_link2 ||
                          card.order_link3 ? (
                            <>
                              <h5 className="fw-bold mb-3">Order Online</h5>
                              <div className="d-flex justify-content-center align-items-center gap-2">
                                {/* Check if the first order link and image are available */}
                                {card.order_link1 && (
                                  <Link
                                    to={card.order_link1}
                                    target="_blank"
                                    style={{ zIndex: "9999" }}
                                  >
                                    <img
                                      src={doorImg}
                                      className="img-fluid d-flex justify-content-center align-items-center"
                                      alt=""
                                      style={{
                                        width: "80px",
                                        height: "30px",
                                        backgroundColor: "white",
                                        padding: "2px 10px",
                                        borderRadius: "25px",
                                      }}
                                    />
                                  </Link>
                                )}

                                {/* Check if the second order link and image are available */}
                                {card.order_link2 && (
                                  <Link
                                    to={card.order_link2}
                                    target="_blank"
                                    style={{ zIndex: "9999" }}
                                  >
                                    <img
                                      src={skipImg}
                                      className="img-fluid d-flex justify-content-center align-items-center"
                                      alt="Skip Image"
                                      style={{
                                        width: "80px",
                                        height: "30px",
                                        backgroundColor: "white",
                                        padding: "2px 10px",
                                        borderRadius: "25px",
                                      }}
                                    />
                                  </Link>
                                )}

                                {/* Check if the third order link and image are available */}
                                {card.order_link3 && (
                                  <Link
                                    to={card.order_link3}
                                    target="_blank"
                                    style={{ zIndex: "9999" }}
                                  >
                                    <img
                                      src={uberImg}
                                      className="img-fluid d-flex justify-content-center align-items-center"
                                      alt="Uber Image"
                                      style={{
                                        width: "80px",
                                        height: "30px",
                                        backgroundColor: "white",
                                        padding: "2px 10px",
                                        borderRadius: "25px",
                                        cursor: "pointer",
                                      }}
                                    />
                                  </Link>
                                )}
                              </div>
                            </>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </>
  );
};

export default TestimonialsLocations;
